/**
 * Customer actions
 */
export enum CustomerActionEnum {
	/**
	 * Set customer status to active
	 */
	ACTIVATE = 'activate',

	/**
	 * Set customer status to closed
	 */
	CLOSE = 'close',

	/**
	 * Set customer status to on hold
	 */
	PUT_ON_HOLD = 'put_on_hold',
}
